<div class="progress-bar-container">
  <div class="progress-bar-background">
    <div class="progress-bar-center">
      <div class="progress-percentage">{{ progress }}%</div>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="370px" height="370px">
        <defs>
          <linearGradient id="GradientColor">
            <stop offset="0%" stop-color="#FE192F"/>
            <stop offset="40%" stop-color="#FFDC11"/>
            <stop offset="50%" stop-color="#FFDC11"/>
            <stop offset="60%" stop-color="#FFDC11"/>
            <stop offset="100%" stop-color="#FE192F"/>
            <!-- <stop offset="0%" stop-color="#DA22FF" /> -->
            <!-- <stop offset="100%" stop-color="#9733EE" /> -->
          </linearGradient>
        </defs>
        <circle cx="185" cy="185" r="180" stroke-linecap="round"
          stroke-dasharray="282.7 848.23"
          [style.stroke-dashoffset]="strokeOffset"
          [style.stroke-dasharray]="strokeDasharray"
        />
      </svg>
    </div>
  </div>
  <div class="progress-title">{{ title }}</div>
  <div class="progress-subtitle">{{ subtitle }}</div>
</div>
